import { createFileRoute } from '@tanstack/react-router';
import {
  loadProductDebitAccountMessages,
  loadProductDebitAccountScreens,
  productDebitAccountScreen,
  productDebitAccountSearch,
} from '@/modules/product-debit-account/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/cadastro/produtos-liquidacao-automatica/')({
  validateSearch: productDebitAccountSearch,
  staticData: { screen: productDebitAccountScreen },
  loader: loadProductDebitAccountMessages,
  component: lazyScreen(loadProductDebitAccountScreens, 'ProductDebitAccountBatchPage'),
});
